import { SidebarTrigger } from '@/components/ui/sidebar-sections';
import { cn } from '@/lib/utils';

export function TopBar({
  className,
  sticky = true,
}: Readonly<{ className?: string; sticky?: boolean }>) {
  return (
    <header
      className={cn(
        'flex h-14 items-center gap-2 border-b bg-background px-4',
        sticky && 'sticky top-0 z-30',
        className,
      )}
    >
      <SidebarTrigger />
      <h1 className="text-base font-semibold">Foundry</h1>
    </header>
  );
}
